import { IAlunosTableDTO } from "../../../../models/happy-code-api.model";
import { PageableResponse } from "../../../../models/response.model";
import { IAlunoTable } from "../../interfaces/aluno-table.interface";

interface UseAlunoTableProps {
  alunosTableData: PageableResponse<IAlunosTableDTO>;
}

export default function useAlunoTable({ alunosTableData }: UseAlunoTableProps) {
  const alunoTableContent = (): IAlunoTable[] => {
    return alunosTableData?.content?.map(
      ({
        alunoNome,
        idAluno,
        statusMatricula,
        dataInicioContrato,
        dataFimContrato,
        idMatricula,
        idFinanceiro,

        quantidadeDeFaltas,
      }) => ({
        nome: alunoNome,
        codigo: "#" + idAluno,
        statusMatricula,
        dataInicioContrato,
        dataFimContrato,
        matricula: "#" + idMatricula,
        idFinanceiro,
        quantidadeDeFaltas,
      })
    ) ?? [];
  };
  const handledAlunoTableData = {
    ...alunosTableData,
    content: alunoTableContent(),
  };

  return {
    handledAlunoTableData,
  };
}
